export enum WorkflowTaskRelativeField {
  STEP_START_DATE = 'stepStartDate',
  COURT_DATE = 'courtDate',
  NOTICE_DATE = 'noticeDate',
}

